module.exports = __webpack_public_path__ + "static/trelinski_fb_1600x630-b334ef3d35e6bd24b94a38e636a740f2.jpg";